module.exports = __webpack_public_path__ + "img/down_arrow.da711708.svg";